module.exports = __webpack_public_path__ + "img/product-1.5547b397.png";